import { ConsentGoalDto } from '@act/shared/data-transfer-objects';
import { CollapsibleCard } from '../../../../containers/Cards/Collapsible/CollapsibleCard';
import { ConsentGoalSummary } from '../summaries/ConsentGoalSummary';
import { ConsentDateLine } from '../dateLines';
import { GoalCardActionItems } from '../../goalCardShared.types';
import { IconAvatar } from '../../../../display/IconAvatar/IconAvatar';

interface ConsentGoalCardProps {
  consent: ConsentGoalDto;
  actions?: GoalCardActionItems[];
  defaultClosed?: boolean;
  onToggleOpen?: () => void;
}

export const ConsentGoalCard = ({
  consent,
  actions,
  defaultClosed,
  onToggleOpen,
}: ConsentGoalCardProps) => {
  return (
    <CollapsibleCard
      avatar={<IconAvatar avatarType="consent" />}
      title={consent.name}
      titleTypographyVariant="titleMedium"
      endContent={<ConsentDateLine consent={consent} />}
      defaultClosed={defaultClosed}
      isCompact
      hideExpander
      shouldShowPointer
      onToggleOpen={onToggleOpen}
    >
      <ConsentGoalSummary consent={consent} actions={actions} />
    </CollapsibleCard>
  );
};
